module.exports = __webpack_public_path__ + "img/org.051d1d95.png";